export default "__VITE_PUBLIC_ASSET__273d2d12__"